import { useMutation } from "react-query";
import api from "../../client";
import { InteractionSortPayload } from "../../types/interaction";

const req = async (payload: InteractionSortPayload): Promise<{}> => {
  const { data } = await api.post(`/interactions/sort`, payload);

  return data;
};

export const useInteractionSort = () => {
  return useMutation((payload: InteractionSortPayload) => {
    return req(payload);
  });
};
